module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("QZzbU"))).then(() => parcelRequire('d0iPb'));